<template>
	<div>
		<el-dialog title="修改" width="640px" class="icon-dialog" :visible.sync="show" @open="open" :before-close="closeForm"
			append-to-body>
			<el-form :size="size" ref="form" :model="form" :rules="rules"
				:label-width="$store.getters.device !== 'mobile' ? '16%' : '90px'">
				<el-row>
					<el-col :span="24">
						<el-form-item label="商品名称" prop="name">
							<el-input v-model="form.name" autoComplete="off" clearable placeholder="请输入商品名称"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="商品价格" prop="price">
							<el-input v-model="form.price" autoComplete="off" clearable placeholder="请输入商品价格"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="折扣价格" prop="discount_price">
							<el-input autoComplete="off" v-model="form.discount_price" clearable placeholder="请输入折扣价格" />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="有效时间" prop="time">
							<el-input autoComplete="off" v-model="form.time" clearable placeholder="请输入有效时间" />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="提成比例" prop="commission">
							<el-input autoComplete="off" v-model="form.commission" clearable placeholder="提成比例0%--100%" />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="二级提成比例" prop="commission1">
							<el-input autoComplete="off" v-model="form.commission1" clearable placeholder="提成比例0%--100%" />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="展示排序" prop="sort">
							<el-input autoComplete="off" v-model="form.sort" clearable placeholder="请输入展示排序" />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="优惠时间" prop="yx_time">
							<el-date-picker type="datetime" placeholder="选择日期" v-model="form.yx_time"
                                        style="width: 80%;" format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :size="size" :loading="loading" type="primary" @click="submit">
					<span v-if="!loading">确 定</span>
					<span v-else>提 交 中...</span>
				</el-button>
				<el-button :size="size" @click="closeForm">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { getshoplistedit } from '../../api/userMG';

export default {
	name: 'bannerupdate',
	props: {
		show: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'small'
		},
		info: {
			type: Object,
		},
	},
	data() {
		return {
			form: {
				name: '',
				price: '',
				discount_price: '',
				time: '',
				commission: '',
				commission1: '',
				sort: '',
				yx_time:''
			},
			loading: false,
			rules: {
			}
		}
	},
	methods: {
		open() {
			this.form = this.info
			this.form.type = 'set'
		},
		submit() {
			this.$refs['form'].validate(valid => {
				if (valid) {
					this.loading = true
					console.log(this.form);
					getshoplistedit(this.form).then(res => {
						if (res.code == 200) {
							this.$message({ message: '操作成功', type: 'success' })
							this.$emit('refesh_list')
							this.closeForm()
						} else {
							this.$message({ message: res.msg, type: 'error' })
							this.loading = false
						}
					}).catch(() => {
						this.loading = false
					})
				}
			})
		},
		closeForm() {
			this.$emit('update:show', false)
			this.loading = false
			if (this.$refs['form'] !== undefined) {
				this.$refs['form'].resetFields()
			}
		},
	}
}
</script>
<style scoped ></style>



// WEBPACK FOOTER //
// src/views/goods/update.vue